import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetCustomerOnboarding as GetCustomerOnboardingQuery,
    GetCustomerOnboarding_customerOnboarding as CustomerOnboarding,
} from 'nutshell-graphql-types';

import GET_CUSTOMER_ONBOARDING from '../queries/get-customer-onboarding.graphql';

export const useGetCustomerOnboarding = (): {
    customerOnboarding: CustomerOnboarding | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetCustomerOnboardingQuery, Record<any, any>>(
        GET_CUSTOMER_ONBOARDING,
        {
            fetchPolicy: 'cache-and-network',
        }
    );

    return {
        customerOnboarding: data && data.customerOnboarding,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
